import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import images from "../../../../../assets/Icons/Icons";

type Props = {
  details: Record<string, string>;
  selectedLevel: string;
};

const InfoTooltip = ({ details, selectedLevel }: Props) => {
  const iconRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const [coords, setCoords] = useState({
    top: 0,
    left: 0,
    position: "bottom" as "top" | "bottom",
  });

  useEffect(() => {
    if (!open || !iconRef.current) return;

    const rect = iconRef.current.getBoundingClientRect();
    const tooltipHeight = 260;

    const spaceBelow = window.innerHeight - rect.bottom;

    const position = spaceBelow < tooltipHeight ? "top" : "bottom";

    setCoords({
      left: rect.left + rect.width / 2,
      top:
        position === "bottom"
          ? rect.bottom + 12
          : rect.top - tooltipHeight + 62,
      position,
    });
  }, [open]);

  return (
    <>
      <div
        ref={iconRef}
        className="tooltip-trigger"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        <img src={images.info} width={20} />
      </div>

      {open &&
        createPortal(
          <div
            className={`portal-tooltip ${coords.position}`}
            style={{
              top: coords.top,
              left: coords.left,
            }}
          >
            <div className="tooltip-arrow" />

            <div className="tooltip-grid">
              {Object.entries(details).map(([level, description]) => (
                <div
                  key={level}
                  className={`tooltip-level ${
                    selectedLevel === level ? "active" : ""
                  }`}
                >
                  <div className="tooltip-title">{level}</div>
                  <div className="tooltip-desc">{description}</div>
                </div>
              ))}
            </div>
          </div>,
          document.body
        )}
    </>
  );
};

export default InfoTooltip;
